import { render, staticRenderFns } from "./CardManagement.vue?vue&type=template&id=1c033c7d&"
import script from "./CardManagement.vue?vue&type=script&lang=js&"
export * from "./CardManagement.vue?vue&type=script&lang=js&"
import style0 from "./CardManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports